import { Box, Grid, Skeleton } from "@mui/material";

const SelectorComponent = ({ textWidth, selectorWidth, widthBtn }: { textWidth?: number; selectorWidth?: number; widthBtn?: boolean }) => {
	return (
		<Grid item>
			<Skeleton className="rounded-[6px]" variant="rectangular" width={textWidth} height={20} />
			<Box className="flex items-center gap-x-2">
				<Skeleton className="mt-2 rounded-md" variant="rectangular" width={selectorWidth} height={30} />
				{widthBtn && (
					<>
						<Skeleton className="mt-2 rounded-full" variant="rectangular" width={50} height={24} />
						<Skeleton className="mt-2 rounded-md" variant="rectangular" width={100} height={18} />
					</>
				)}
			</Box>
		</Grid>
	);
};

const SystemSettingsLoader = () => {
	return (
		<>
			<Grid container direction="column" pl={"20px"}>
				<Skeleton className="rounded-[6px] mt-1" variant="rectangular" width={380} height={30} />
				<SelectorComponent textWidth={0} selectorWidth={240} />
				<Skeleton className="mt-[22px] rounded-[6px]" variant="rectangular" width={300} height={30} />
				<SelectorComponent textWidth={0} selectorWidth={240} />
			</Grid>

			<Grid container pt={3} pl={"20px"} spacing={4} className="pb-[100px]">
				{Array.from({ length: 4 }).map((_, i) => {
					const selectorIndex = i;
					return <SelectorComponent key={selectorIndex} textWidth={200} selectorWidth={240} widthBtn />;
				})}
			</Grid>
		</>
	);
};

export default SystemSettingsLoader;
